/** Stable anonymous id for public card uniqueness (localStorage). */
export function getVisitorId() {
  const key = 'ryan_qr_visitor_id';
  try {
    let id = window.localStorage.getItem(key);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(key, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function deviceType() {
  const ua = navigator.userAgent || '';
  if (/iPad|Tablet|Kindle|Silk/i.test(ua)) return 'tablet';
  if (/Mobi|iPhone|iPod|Android/i.test(ua)) return 'mobile';
  return 'desktop';
}

/** Fire-and-forget analytics POST; never throws to callers. */
export function postAnalytics(url, body) {
  const payload = JSON.stringify(body);
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    credentials: 'omit',
    keepalive: true,
  }).catch(() => {});
}
